import { convertToDecimals, currency } from '@pharmaplan/common';
import fr from '@pharmaplan/common/localization/fr';
import en from '@pharmaplan/common/localization/en';
import strings from '../../localization';

type IInvoiceConfig = {
  totalRate: number | string | null;
  meal: number;
  travel: number;
  accommodation: number;
  emergency: number;
  other?: number;
  subTotal?: number | string | null;
  totalTPS?: number | string | null;
  totalTVQ?: number | string | null;
  grandTotal?: number | string | null;
  tps: string;
  tvq: string;
};

type IBankConfig = {
  institutionNo: string;
  branchNo: string;
  accountNo: string;
};

type IProfessionalConfig = {
  professionalName: string;
  address: string;
  phone: string;
  email: string;
};

type IClientConfig = {
  clientName: string;
  address: string;
  email: string;
};

export const clientConfig = ({ clientName, address, email }: IClientConfig) =>
  [
    {
      label: strings.pharmacyName,
      value: clientName,
    },
    {
      label: strings.email,
      value: email,
    },
    {
      label: strings.pharmacyAddress,
      value: address,
    },
  ];

export const professionalConfig = ({
  professionalName,
  address,
  phone,
  email,
}: IProfessionalConfig) =>
  [
    {
      label: `${strings.professional}/${strings.companyName}`,
      value: professionalName,
    },
    {
      label: strings.email,
      value: email,
    },
    {
      label: strings.address,
      value: address,
    },
    {
      label: strings.phoneNumber,
      value: phone,
    },
  ];

export const bankConfig = ({
  branchNo,
  institutionNo,
  accountNo,
}: IBankConfig) =>
  [
    {
      label: strings.branchNo,
      value: branchNo,
    },
    {
      label: strings.institutionNo,
      value: institutionNo,
    },
    {
      label: strings.accountNo,
      value: accountNo,
    },
  ];

export const invoiceConfig = ({
  emergency,
  meal,
  other,
  subTotal,
  accommodation,
  travel,
  grandTotal,
  totalRate,
  totalTPS,
  totalTVQ,
  tps,
  tvq,
}: IInvoiceConfig) =>
  [
    {
      key: 1,
      label: `${fr.totalWorkedHours}/${en.totalWorkedHours}`,
      value: `${currency}${convertToDecimals(parseFloat(totalRate as string))}`,
    },
    {
      key: 2,
      label: `${fr.meal}/${en.meal}:`,
      value: `${currency}${convertToDecimals(meal)}`,
    },
    {
      key: 3,
      label: `${fr.travel}/${en.travel}: `,
      value: `${currency}${convertToDecimals(travel)}`,
    },
    {
      key: 4,
      label: `${fr.accomodation}/${en.accomodation}:`,
      value: `${currency}${convertToDecimals(accommodation)}`,
    },
    {
      key: 5,
      label: `${fr.emergency}/${en.emergency}:`,
      value: `${currency}${convertToDecimals(emergency)}`,
    },
    {
      key: 6,
      label: `${fr.other}/${en.other}:`,
      value: `${currency}${convertToDecimals(other)}`,
    },
    {
      key: 7,
      label: `${fr.subTotal}/${en.subTotal}:`,
      value: `${currency}${convertToDecimals(parseFloat(subTotal as string))}`,
    },
    {
      key: 8,
      label: `TPS/GST ${tps}%:`,
      value: `${currency}${convertToDecimals(parseFloat(totalTPS as string))}`,
    },
    {
      key: 9,
      label: `TVQ/QST ${tvq}%:`,
      value: `${currency}${convertToDecimals(parseFloat(totalTVQ as string))}`,
    },
    {
      key: 10,
      label: `${strings.total}:`,
      value: `${currency}${convertToDecimals(parseFloat(grandTotal as string))}`,
    },
  ];
